import { lazyGetAttachment } from 'owa-attachment-model-store';
import { ClientAttachmentId } from 'owa-client-ids';
import { PreviewPaneMode, RightPaneDisplay } from 'owa-sxsdata';
import { mutator } from 'satcheljs';
import { internalCloseSxS } from '../actions/internalActions';
import { showSxS } from '../actions/publicActions';
import { onChangeByImageGallery } from '../actions/publicLazyActions';
import getOrCreateSxSStoreData from '../store/Store';

mutator(showSxS, actionMessage => {
    const { sxsId } = actionMessage;
    getOrCreateSxSStoreData(sxsId).viewState.minRightPaneWidth = 420;
});

mutator(internalCloseSxS, actionMessage => {
    const { sxsId } = actionMessage;
    const sxsStore = getOrCreateSxSStoreData(sxsId);
    sxsStore.viewState.rightPaneDisplay = RightPaneDisplay.Initial;
    sxsStore.viewState.didAutoHideRightPane = false;
});

mutator(onChangeByImageGallery, actionMessage => {
    const { sxsId } = actionMessage;
    const sxsStore = getOrCreateSxSStoreData(sxsId);
    if (sxsStore.viewState.previewPane.mode === PreviewPaneMode.Image) {
        const getAttachment = lazyGetAttachment.tryImportForRender();
        if (getAttachment) {
            const currentAttachmentId: ClientAttachmentId = sxsStore.viewState.previewPane.id;
            const attachmentModel = getAttachment(currentAttachmentId);
            if (attachmentModel && !!attachmentModel.model) {
                sxsStore.viewState.previewPane.fileName = attachmentModel.model.Name;
            }
        }
    }
});
